import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    cardStyle: {
      display: "flex",
      padding: theme.spacing(3),
      width: "53rem",
      minWidth: '53rem',
      height: "15rem",
      overflow: "visible",
      [theme.breakpoints.down("xs")]: {
        width: "360px",
        minWidth: "360px",
        maxWidth: "100%",
        flexDirection: 'column',
        gap: '8px',
        height: "auto",
      },
    },
    leftSection: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      width: "400px",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
      },
    },
    middleInfo: {
      display: "flex",
      gap: "12px",
    },
    middleSection: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "26px",
      width: "400px",
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        marginTop: theme.spacing(2),
      },
    },
    rightSection: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      height: "100%",
      paddingTop: theme.spacing(1),
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        alignItems: "flex-start",
        marginTop: theme.spacing(2),
      },
    },
    buttonSkeleton: {
      marginTop: 0,
      marginBottom: theme.spacing(2),
      borderRadius: 8,
    },
  };
});
